const backend_url = process.env.NEXT_PUBLIC_BACKEND_URL; // if you have a client-side environment variable name must be set NEXT_PUBLIC_xxxxx;

export const api_url = {
   user: "/api/user/{id}",
   login: "/api/auth/login",
   signup: "/api/auth/signup",
   google_login: "/api/auth/google",
   milvus_url: "/api/milvus",
   milvus_embeddings_url: "/api/milvus/embeddings",
   chat_history_url: "/api/chat-history",
   chat_stream_url: "/api/chat/stream/{id}",
   chat_history_messages_url: "/api/chat-history/messages",
   chat_history_share_url: "/api/chat-history/share",
   chat_history_share_invitee_url: "/api/chat-history/share/invitee",
   chat_history_share_invites_url: "/api/chat-history/share/invites",
   chat_history_share_access_url: "/api/chat-history/share/access",
   chat_history_pin_url: "/api/chat-history/pin",
   chat_history_fork_url: "/api/chat-history/fork",
   chat_history_search_url: "/api/chat-history/search",
   chat_history_feedback_url: "/api/chat-history/feedback",
   chat_history_feedback_restore: "/api/chat-history/feedback/restore",
   config_url: "/api/config",
   verify_token_url: "/api/auth/verify-token",
   shared_login_url: "/api/auth/shared-login",
   rag_assessment_url: "/api/rag-assessment",
   rag_assessment_evaluate_url: "/api/rag-assessment/evaluate",
   rag_assessment_synthetic_url: "/api/rag-assessment/synthetic",
   model_configs: "/api/model-configs",
   document_processing: "/api/document-processing",
   upload_url: "/api/upload",
   chat_attachment_init_url: "/api/chat-attachments/uploads/init",
   chat_attachment_complete_url: "/api/chat-attachments/{id}/complete",
   chat_attachment_status_url: "/api/chat-attachments/{id}/status",
   file_url: "/api/files/{id}",
   public_file_url: "/api/uploads/{storageKey}",
   usage_url: "/api/usage",
   user_list_url: "/api/user/list",
   semantic_chunking_url: "/api/semantic-chunking",
   milvus_semantic_search_url: "/api/milvus/semantic-search",
   milvus_fulltext_search_url: "/api/milvus/fulltext-search",
   milvus_hybrid_search_url: "/api/milvus/hybrid-search",
   milvus_record_url: "/api/milvus/record",
   feedback_analysis_url: "/api/auth/feedback/feedback-analysis",
   feedback_list_url: "/api/auth/feedback/list",
   feedback_label_url: "/api/auth/feedback/label",
   feedback_resolution_url: "/api/auth/feedback/resolution",
   feedback_detail_url: "/api/auth/feedback/{id}",
   feedback_llm_assist_url: "/api/auth/feedback/llm-assist",
   user_engagement_url: "/api/auth/user-engagement",
   ka_posts_url: "/api/auth/ka-posts",
   insights_clusters_url: "/api/auth/insights/clusters",
   insights_cluster_members_url: "/api/auth/insights/clusters/{clusterId}/members",
   insights_clusters_run_status_url: "/api/auth/insights/clusters/run-status",
   insights_clusters_run_url: "/api/auth/insights/clusters/run",
   insights_clusters_revoke_url: "/api/auth/insights/clusters/revoke",
   insights_clusters_reopen_hidden_url: "/api/auth/insights/clusters/reopen-hidden",
   insights_outcomes_run_url: "/api/auth/insights/outcomes/run",
   insights_topics_propose_url: "/api/auth/insights/topics/propose",
   insights_topics_run_url: "/api/auth/insights/topics/run",
   insights_market_sync_url: "/api/auth/insights/market/sync",
   insights_report_url: "/api/auth/insights/report",
   user_memory_list_url: "/api/auth/user-memory/list",
   user_memory_settings_url: "/api/auth/user-memory/settings",
   user_memory_my_settings_url: "/api/auth/user-memory/my-settings",
   user_memory_worker_url: "/api/cron/run-memory-worker",
   memory_evaluation_url: "/api/memory-evaluation",
   memory_evaluation_run_url: "/api/memory-evaluation/evaluate",
   memory_evaluation_evidence_url: "/api/memory-evaluation/evidence",
   chart_data_url: "/api/chart-data",
   admin_smoke_url: "/api/admin/smoke",
   admin_smoke_deploy_hook_url: "/api/admin/smoke/deploy-hook",
   admin_smoke_health_url: "/api/admin/smoke/health",
   backend_url: backend_url,
   backend_upload_url: backend_url + "/upload",
   backend_chat_attachment_init_url: backend_url + "/chat-attachments/uploads/init",
   backend_chat_attachment_complete_url: backend_url + "/chat-attachments/{id}/complete",
   backend_chat_attachment_status_url: backend_url + "/files/{id}/status",
   backend_file_url: backend_url + "/files/{id}",
   backend_public_file_url: backend_url + "/uploads/{storageKey}",
   backend_graphql_url: backend_url + "/graphql",
   redis_url: process.env.REDIS_URL || "redis://localhost:6379"
};
